export const actions = {
  set: 'SET_PROP',
  reset: 'RESET_UX',
  showDetailPanel: 'SHOW_SLIDE',
  hideDetailPanel: 'HIDE_SLIDE',
  bypassDetailPanel: 'BYPASS_SLIDE',
  setLoad: 'SET_LOAD',
  setHighlight: 'SET_HIGHLIGHT',
  clearLocation: 'CLEAR_LOCATION',
  setAccessiblity: 'SET_ACCESSIBILITY',
};

/**
 * Set ux prop
 * @param  {Object} prop    Prop to change in ux store
 * @return {Object}         Action to update ux store
 */
export const setUXProp = prop => ({
  type: actions.set,
  prop: prop,
});

export const resetUX = () => ({
  type: actions.reset,
});

export const showDetailPanel = () => ({
  type: actions.showDetailPanel,
});

export const hideDetailPanel = () => ({
  type: actions.hideDetailPanel,
});

export const bypassDetailPanel = () => ({
  type: actions.bypassDetailPanel,
});

export const setDetailPanelTarget = id => ({
  type: actions.set,
  prop: {
    detailPanel: {
      display: true,
      id: id,
      bypass: false,
    },
  },
});

export const clearDetailPanel = () => ({
  type: actions.set,
  prop: {
    detailPanel: {
      display: false,
      id: null,
      bypass: false,
    },
  },
});

export const setAccessibilityValue = (name, value) => ({
  type: actions.setAccessiblity,
  prop: {
    name: name,
    value: value,
  },
});
export const setHighlightValue = (name, value) => ({
  type: actions.setHighlight,
  prop: {
    name: name,
    value: value,
  },
});

export const setLoad = prop => ({
  type: actions.setLoad,
  prop: prop,
});

export const clearLocation = () => ({
  type: actions.clearLocation,
});
